/* DUNKPOINT bundle offer ("buy X, get Y free").
   - Redraws every progress strip ([data-dp-bundle], snippets/dp-bundle-progress.liquid).
   - Drives the picker page (sections/dp-bundle-builder.liquid): slots, sticky bar, load more.
   It does not talk to the cart itself for normal updates: dp-cart.js fires
   "dp:cart:updated" with the /cart.js payload every time it re-renders the
   drawer, and this file listens to that. /cart.js is only fetched as a
   fallback when the drawer script is not on the page. */
(function () {
  'use strict';
  if (window.dpBundle) return;

  var listeners = [];
  var lastCart = null;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    if (typeof window.dpMoney === 'function') return window.dpMoney(cents);
    return (cents / 100).toFixed(2);
  }

  /* Only lines with a price count, like the bundle-eligible collection. */
  function eligible(cart) {
    return ((cart && cart.items) || []).filter(function (item) { return item.original_price > 0; });
  }

  function countOf(cart) {
    return eligible(cart).reduce(function (n, item) { return n + item.quantity; }, 0);
  }

  function state(qty, buy, get) {
    var group = buy + get;
    var rest = qty % group;
    var unlocked = qty > 0 && rest === 0;
    return {
      qty: qty, buy: buy, get: get, group: group, rest: rest, unlocked: unlocked,
      need: group - rest,
      filled: unlocked ? group : rest,
      sets: Math.floor(qty / group)
    };
  }

  /* Same maths as the Liquid first paint: four milestones, sliding along
     once the shopper passes the third one. */
  function paintStrip(el, cart) {
    var buy = Number(el.getAttribute('data-buy')) || 2;
    var get = Number(el.getAttribute('data-get')) || 1;
    var s = state(countOf(cart), buy, get);
    el.hidden = s.qty === 0;
    el.classList.toggle('is-unlocked', s.unlocked);

    var msg = el.querySelector('[data-dp-bundle-msg]');
    if (msg) {
      var target = s.unlocked ? s.qty : s.qty + s.need;
      var tpl = el.getAttribute(s.unlocked ? 'data-unlocked' : 'data-progress');
      msg.innerHTML = esc(tpl)
        .replace('[n]', '<b>' + s.need + '</b>')
        .replace('[p]', '<b>' + (target / s.group) * buy + '</b>')
        .replace('[g]', '<b>' + target + '</b>');
    }

    var track = el.querySelector('[data-dp-bundle-track]');
    if (!track) return;
    var next = s.sets + 1;
    var start = Math.max(1, next - 3);
    var fill = Math.min(100, Math.max(0, (s.qty - (start - 1) * s.group) * 100 / (s.group * 4)));
    var wBuy = esc(el.getAttribute('data-word-buy') || 'Buy');
    var wPay = esc(el.getAttribute('data-word-pay') || 'pay');
    var html = '<span class="dp-bnd__fill" style="width: ' + fill + '%"></span>';
    for (var i = 0; i < 4; i++) {
      var k = start + i;
      var q = k * s.group;
      var cls = s.qty >= q ? ' is-done' : (k === next ? ' is-next' : '');
      html += '<span class="dp-bnd__step' + cls + '" style="left: ' + (i + 1) * 25 + '%">' +
        '<i></i><b>' + wBuy + ' ' + q + '</b><small>' + wPay + ' ' + k * buy + '</small></span>';
    }
    track.innerHTML = html;
  }

  function update(cart) {
    if (!cart || !cart.items) return;
    lastCart = cart;
    document.querySelectorAll('[data-dp-bundle]').forEach(function (el) { paintStrip(el, cart); });
    listeners.forEach(function (fn) { try { fn(cart); } catch (e) {} });
  }

  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(update)
      .catch(function () {});
  }

  document.addEventListener('dp:cart:updated', function (e) { update(e.detail && e.detail.cart); });

  /* Fallback for pages without the drawer script: re-read the cart after a
     quick add or a cart change made elsewhere. */
  document.addEventListener('click', function (e) {
    if (document.querySelector('[data-dp-cart]')) return;
    if (e.target.closest('[data-qa-add]')) setTimeout(refresh, 1500);
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  window.dpBundle = {
    state: state,
    count: countOf,
    refresh: refresh,
    onCart: function (fn) { listeners.push(fn); if (lastCart) fn(lastCart); }
  };

  /* ------------------------------------------------------- picker page ---- */
  function initBuilder(root) {
    var buy = Number(root.getAttribute('data-buy')) || 2;
    var get = Number(root.getAttribute('data-get')) || 1;
    var slotsEl = root.querySelector('[data-bb-slots]');
    var bar = root.querySelector('[data-bb-bar]');
    var barCount = root.querySelector('[data-bb-count]');
    var setsEl = root.querySelector('[data-bb-sets]');
    var setsTpl = root.getAttribute('data-sets-text') || '';
    var emptyLabel = root.getAttribute('data-empty-label') || '';
    var freeLabel = root.getAttribute('data-free-label') || '';
    var barTpl = root.getAttribute('data-bar-text') || '[count]/[total]';

    function units(cart) {
      /* /cart.js lists the newest line first; slots fill in the order added. */
      var list = [];
      eligible(cart).slice().reverse().forEach(function (item) {
        for (var q = 0; q < item.quantity; q++) list.push(item);
      });
      return list;
    }

    function paint(cart) {
      var all = units(cart);
      var s = state(all.length, buy, get);
      var start = s.unlocked ? all.length - s.group : all.length - s.rest;
      var set = all.slice(start, start + s.group);

      /* Mark the free one only while there is a single set: Shopify gives the
         lowest-priced eligible items in the whole cart, not per set. */
      var freeIndex = -1;
      if (s.unlocked && s.qty === s.group) {
        var low = Infinity;
        set.forEach(function (item, i) { if (item.final_price <= low) { low = item.final_price; freeIndex = i; } });
      }

      var html = '';
      for (var i = 0; i < s.group; i++) {
        var item = set[i];
        var isFreeSlot = i >= buy;
        if (item) {
          var img = item.image ? '<img src="' + esc(item.image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2')) + '" alt="" loading="lazy">' : '';
          html += '<div class="dp-bb__slot is-filled' + (i === freeIndex ? ' is-free' : '') + '">' +
            '<span class="dp-bb__slotnum">' + (i + 1) + '</span>' +
            (i === freeIndex && freeLabel ? '<span class="dp-bb__freetag">' + esc(freeLabel) + '</span>' : '') +
            '<span class="dp-bb__slotimg">' + img + '</span>' +
            '<span class="dp-bb__slotname">' + esc(item.product_title) + '</span>' +
            '<span class="dp-bb__slotprice">' + money(item.final_price) + '</span>' +
            '</div>';
        } else {
          html += '<div class="dp-bb__slot' + (isFreeSlot ? ' is-freeslot' : '') + '">' +
            '<span class="dp-bb__slotnum">' + (i + 1) + '</span>' +
            '<span class="dp-bb__slotimg dp-bb__slotimg--empty" aria-hidden="true">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></span>' +
            '<span class="dp-bb__slotname">' + esc(isFreeSlot && freeLabel ? freeLabel : emptyLabel) + '</span>' +
            '</div>';
        }
      }
      slotsEl.innerHTML = html;
      root.classList.toggle('is-unlocked', s.unlocked);

      if (barCount) barCount.textContent = barTpl.replace('[count]', s.filled).replace('[total]', s.group);
      if (bar) bar.classList.toggle('is-unlocked', s.unlocked);
      if (setsEl) {
        var freeSoFar = s.sets * get;
        setsEl.hidden = !(freeSoFar > 0 && !(s.unlocked && s.qty === s.group));
        setsEl.textContent = setsTpl.replace('[n]', freeSoFar);
      }
    }

    /* With the offer switched off the section has no slots: only load more runs. */
    if (slotsEl) {
      var initial = root.querySelector('[data-bb-cart]');
      if (initial) {
        try { paint(JSON.parse(initial.textContent)); } catch (e) {}
      }
      window.dpBundle.onCart(paint);
      if (!document.querySelector('[data-dp-cart]')) refresh();
    }

    /* Load more: fetch the next page of this section only and append its cards. */
    var more = root.querySelector('[data-bb-more]');
    var grid = root.querySelector('[data-bb-grid]');
    if (more && grid) {
      more.addEventListener('click', function () {
        var url = more.getAttribute('data-next');
        if (!url || more.disabled) return;
        more.disabled = true;
        more.setAttribute('aria-busy', 'true');
        fetch(url, { headers: { Accept: 'text/html' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var nextGrid = doc.querySelector('[data-bb-grid]');
            if (nextGrid) {
              while (nextGrid.firstElementChild) grid.appendChild(nextGrid.firstElementChild);
            }
            var nextMore = doc.querySelector('[data-bb-more]');
            var nextUrl = nextMore && nextMore.getAttribute('data-next');
            if (nextUrl) {
              more.setAttribute('data-next', nextUrl);
              more.disabled = false;
            } else {
              more.hidden = true;
            }
            more.removeAttribute('aria-busy');
          })
          .catch(function () { more.disabled = false; more.removeAttribute('aria-busy'); });
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-dp-bb]').forEach(initBuilder);
    if (lastCart) update(lastCart);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
